import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { api } from "../helpers/api";

const useCategories = create(
  devtools((set) => ({
    categories: [],
    categoriesLoading: false,
    fetchCategories: async () => {
      set({ categoriesLoading: true });
      try {
        const { data } = await api.get("client/category-list");
        set({
          categories: data?.data,
        });
        return data?.data;
      } catch (err) {
        return err;
      } finally {
        set({ categoriesLoading: false });
      }
    },
  }))
);

export default useCategories;
